const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function marketingPage(pathname) {
  if (pathname === "/") return "home";
  if (pathname === "/pricing") return "pricing";
  if (pathname === "/signup") return "signup";
  if (pathname === "/signin") return "signin";
  if (pathname === "/demo") return "demo";
  if (pathname === "/privacy-policy") return "privacy";
  if (pathname.startsWith("/templates/")) return "template";
  return "other";
}

export function trackMarketing(event, { page, language = "en", plan = null } = {}) {
  const payload = JSON.stringify({ event, page: page || marketingPage(window.location.pathname), language, plan });
  fetch(`${API}/marketing/events`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    keepalive: true,
    body: payload,
  }).catch(() => {});
}
